import { useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Alert, AlertTitle } from '@material-ui/lab';

import { register } from '../../services/Register';

const MainContainer = styled(Paper)`
    width: 500px;
    max-width: 100%;
    padding: 16px;
`;

const StyledTextField = styled((props) => (
    <TextField variant="filled" fullWidth {...props} />
))`
    margin-bottom: 16px;
`;

const StyledAlert = styled(Alert)`
    margin-bottom: 16px;
`;

const STATUS_INITIAL = 0;
const STATUS_SUBMITTING = 1;
const STATUS_SUCCES = 2;
const STATUS_FAILED = 3;

const Register = () => {
    const { t } = useTranslation();
    const [formValues, setFormValue] = useState({ name: '', email: '' });
    const [status, setStatus] = useState(STATUS_INITIAL);
    const [responseMsg, setResponseMsg] = useState(null);

    const { enqueueSnackbar } = useSnackbar();

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const game = query.get('game');

    const handleInputChange = (key) => (event) =>
        setFormValue((prev) => ({ ...prev, [key]: event.target.value }));

    const handleSubmit = () => {
        if (!(formValues.name && formValues.email)) {
            enqueueSnackbar(t('error.notAllFieldsComplete'), {
                variant: 'warning',
            });
        } else {
            setStatus(STATUS_SUBMITTING);
            setResponseMsg(null);
            register(formValues.name, formValues.email, game)
                .then((registerResult) => {
                    setStatus(STATUS_SUCCES);
                })
                .catch((err) => {
                    setResponseMsg(err.message);
                    setStatus(STATUS_FAILED);
                });
        }
    };

    if (!game) {
        return (
            <MainContainer>
                <Alert severity="error">
                    <AlertTitle>{t('error.urlNotComplete')}</AlertTitle>
                    {t('error.missingGameParameter')}
                </Alert>
            </MainContainer>
        );
    }

    if (status === STATUS_SUCCES) {
        return (
            <MainContainer>
                <Alert severity="success">
                    <AlertTitle>
                        {t('register.registrationSentConfirmation.title')}
                    </AlertTitle>
                    {t('register.registrationSentConfirmation.content')}
                </Alert>
                <p></p>
            </MainContainer>
        );
    }

    let alert = null;
    if (status === STATUS_FAILED) {
        alert = (
            <StyledAlert severity="error">
                <AlertTitle>{t('error.registrationFailed')}</AlertTitle>
                {t('error.errorWhileRegistration')}
                <p>
                    <i>{responseMsg}</i>
                </p>
            </StyledAlert>
        );
    }
    return (
        <MainContainer>
            <h3>{t('register.registerHeader')}</h3>
            {alert}
            <StyledTextField
                id="name"
                label={t('register.name')}
                value={formValues.name}
                onChange={handleInputChange('name')}
                required
            />
            <StyledTextField
                id="email"
                type="email"
                label={t('register.email')}
                value={formValues.email}
                onChange={handleInputChange('email')}
                required
            />
            <Button
                color="primary"
                onClick={handleSubmit}
                variant="contained"
                fullWidth
                disable={status === STATUS_SUBMITTING}
            >
                {t('register.register')}
            </Button>
        </MainContainer>
    );
};

export default Register;
